/**
 * Mimics the slot functionality of
 * Web Components
 *
 * Slots are named, their name & location is
 * predefined in the component.
 *
 * @param Element
 * @param name
 * @param cb
 */
export default function slot(Element, name, cb) {
    if (arguments.length === 2) {
        Element.kompo.slots[name](Element);
        return;
    }
    if (cb) {
        Element.kompo.slots[name] = cb;
        return;
    }
    throw Error('invalid slot setting or calling');
}
/**
 * Checks whether a slot with the given name exists
 *
 * @param Element
 * @param name
 * @returns {boolean}
 */
export function hasSlot(Element, name) {
    return !!Element.kompo.slots[name];
}
//# sourceMappingURL=slot.js.map


//////////////////
// WEBPACK FOOTER
// ./~/kompo/lib/component/slot.js
// module id = 14
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11